export const HOME_LOADING = 'HOME_LOADING';
export const HOME_FULFILLED = 'HOME_FULFILLED';
